import { useEffect } from "react";
import { each } from "lodash";

export default function useRequestError(requestErrors, setError) {
    useEffect(() => {
        each(requestErrors, (errs, field) => {
          setError(field, {type: 'custom', message: errs?.[0]})
        })
      },[requestErrors, setError])
}